exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge[data-v-7571ddb2]{cursor:default!important}.master-name[data-v-7571ddb2]{color:grey;font-size:70%;font-style:italic}.mw-270[data-v-7571ddb2]{max-width:270px}", ""]);

// exports
